import React from 'react';
import { FormattedMessage } from 'react-intl';


//компонент меню для роли пользователя (включая неавторизованного), содержащий ссылки с правой стороны
const PersonMenu = ({data, handleMenuClose}) => {
    return ( 
        <div className='Menu__list'>
            <a href='/profile' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='header.about.me' />
            </a>
            <a href='/lots' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='mobile_menu.auctions' />
            </a>
            <a href='/personvisits' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='header.visits' />
            </a>
            <a href='/persondocuments' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='header.ducuments' />
            </a>
            {/*<a href='/reporting' onClick={handleMenuClose}className='Menu__link Link Head Link_single Link_light'>
                <FormattedMessage id='header.reporting' />
            </a>*/}
            <a href='/help' onClick={handleMenuClose} className='Menu__link Link Head Link_single Link_light SupportLink'>
                <FormattedMessage id='support.project' />
            </a>
        </div>
    )
}

export default PersonMenu;


// WEBPACK FOOTER //
// ./src/components/MenuComponents/mobileMenu/MenuListPerson.jsx